import { DatePicker } from "antd";
import { GrFormClose } from "react-icons/gr";
import TextComponent from "../textComponent/TextComponent";
import styles from "./DateInput.module.css";

const DateInput = (props) => {
  return (
    <div className={`${styles.main_input} ${props?.className}`}>
      <text className={` ${styles.label} ${props?.labelClass} `}>
        <TextComponent>{props?.label}</TextComponent>
      </text>
      <DatePicker
        style={{ border: "1px solid var(--border-color)", boxShadow: "none" }}
        placeholder={props?.placeholder ? props?.placeholder : "Select Date"}
        value={props?.value}
        defaultValue={props?.defaultValue}
        use12Hours
        format="YYYY-MM-DD"
        onChange={props?.onChange}
        suffixIcon={props?.icon}
        className={`${styles.inner_input} ${props?.inputClass}`}
        inputReadOnly
        clearIcon={
          <div className={styles.clearIconBtn}>
            <GrFormClose
              className={styles.clearIcon}
              style={{ color: "var(--secondary-color)" }}
            />
          </div>
        }
      />
    </div>
  );
};

export default DateInput;
